export const onClientEntry = () => {
  if (typeof window.IntersectionObserver === 'undefined') {
    require('intersection-observer');
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let i = 0; i < registrations.length; i++) {
        registrations[i].unregister();
      }
    });
    if ('caches' in window) {
      caches.keys().then(function (names) {
        for (let i = 0; i < names.length; i++) {
          caches.delete(names[i]);
        }
      });
    }
  }
};

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.hash) {
    return true;
  }

  const savedPosition = getSavedScrollPosition(location);
  if (savedPosition) {
    return savedPosition;
  }

  return [0, 0];
};

export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    return;
  }

  window.scrollTo(0, 0);

  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
};
